// 按页面划分
export default {
    // 公共页面
    common: {
        title: "Pusat Data",
        pull_refresh: 'Tarik ke bawah untuk menyegarkan',
        release_refresh: 'Lepaskan untuk menyegarkan',
        refresh_loading: 'Memuat…',
        footer_text: 'Layanan disediakan oleh Ucloudlink (NASDAQ: UCL)'
    },
    home: {
        input_placeholder: 'Telusuri negara/wilayah',
        my_flow: 'Data saya',
        charge_code: 'Kode Voucher',
        coupons:'Kupon',
        local_package: 'Data Lokal',
        more: 'Lagi',
        popular_destination: 'Negara/wilayah',
        buy_now: 'Beli sekarang',
        package_useing: 'Aktif',
        unused: 'Tidak aktif',
        download_app: 'Unduh Aplikasi',
        enter_the_mall_list: 'Masuk ke Mal',
        no_data: 'Tidak ada data',
        no_data_available: 'Tidak ada data tersedia',
        copy_success: 'Berhasil disalin',
        copy_fail: 'Gagal menyalin',
        meritsTitle: 'Apa Kelebihannya?',
        merits1: 'Tanpa SIM & Tanpa Biaya Bulanan',
        merits2: 'Terintegrasi dengan 2-3 operator teratas untuk pengalihan jaringan otomatis',
        go_buy: 'Pergi untuk membeli',
        instant_savings: 'Hemat',
        expires_in: 'Kadaluarsa dalam',
        download_app_tips: "Unduh aplikasinya untuk penawaran & pengalaman lebih banyak"
    },
    packages: {
        sub_title: {
            us: 'Tidak termasuk Guam, Saipan',
            it: 'Termasuk Kota Vatikan, San Marino',
            va: 'Termasuk Italia, San Marino',
            sm: 'Termasuk Italia, Kota Vatikan',
            ma: 'Termasuk Sahara Barat',
            eh: 'Termasuk Maroko',
            ch: 'Termasuk Liechtenstein',
            li: 'Termasuk Swiss',
            fr: 'Termasuk Monako',
            mc: 'Termasuk Perancis',
            fi: 'Termasuk Kepulauan Aland',
            ax: 'Termasuk Finlandia',
            gu: 'Termasuk Kepulauan Mariana Utara',
            mp: 'Termasuk Guam'
        },
        unlimited_packages: 'Paket data tidak terbatas',
        normal_packages: 'Paket data biasa',
        multi_region_packages: 'Multi-wilayah',
        regional_data: 'Data Regional',
        high_speed_text: 'data berkecepatan tinggi',
        infiniteFlow: 'Data tanpa batas',
        unLimitData: 'Tak Terbatas',
        high_speed_text_year: 'kecepatan tinggi/mp',
        package_list: 'Daftar paket',
        special_offer: 'Penjualan',
        first_month: '1 Bulan',
        periodUnit: {
            day: 'hari',
            month: 'bulan',
            hour: 'jam',
            year: 'tahun',
        },
        periodUnits: {
            day: 'hari',
            month: 'bulan',
            hour: 'jam',
            year: 'tahun',
        },
        periodUnitSimp: {
            day: 'D',
            month: 'untuk',
            hour: 'H',
            year: 'itu'
        },
        periodUnitMonthly:'Bulanan',
        periodUnitsSimp: {
            day: 'D',
            month: 'untuk',
            hour: 'H',
            year: 'itu'
        },
        unlimited_good_name: {
            day: 'Tiket Masuk Sehari',
            month: 'Tiket Bulanan',
            year: 'Tiket Masuk Tahunan'
        },
        continuousMonth: "Bulan terus menerus",
        continuousDay: "Hari -hari yang berkelanjutan",
        continuousYear: "Tahun -tahun terus menerus",


        day_invalid: 'Berakhir pada hari ini',
        month_invalid: 'Berakhir pada bulan ini',
        immediate_valid: 'Segera efektif',
        tomorrow_day_valid: 'Efektif mulai hari berikutnya',
        tomorrow_month_valid: 'Efektif mulai bulan depan',


        // detail page
        detail: {
            cell_flow: 'Data',
            cell_period: 'Keabsahan',
            buy_quantity: 'Jumlah',
            use_area: 'Cakupan',
            use_intro: 'syarat dan Ketentuan',
            buy_btn: 'Memesan',
            pay: 'Bayar',
            buy_tips: 'Anda memiliki paket %@packageName sedang digunakan. Ingin membeli paket ini?',
            haveOrderTips: "Pesanan menunggu pembayaran dibuat. Klik Konfirmasi ke Halaman Data Saya untuk lihat！"
        },

        // confirm page
        confirm: {
            title: 'Konfirmasi pesanan',
            real_pay_amount: 'Jumlah yang dibayarkan',
            online_payment: 'Pembayaran Daring',
            create_order_error: 'Penyiapan gagal'
        }
    },
    pay: {
        // result page
        result: {
            loading_order_status: 'Mendapatkan status pesanan…',
            buy_success: 'Pesanan selesai',
            buy_pending: 'Menunggu konfirmasi',
            buy_pending_tip: 'Pembayaran sedang diproses…Jika pembayaran tidak ditransfer dalam 10 menit, silakan hubungi kami untuk mendapatkan dukungan.',
            get_payment_info_fail: 'Akuisisi info pembayaran gagal',
            cell_package: 'Kemasan',
            cell_buy_amount: 'Subtotal',
            cell_real_amount: 'Jumlah yang dibayarkan',
            go_to_order_btn: 'Buka Paket Saya',
            back_home: 'Kembali ke Rumah',
            back_mall: 'Kembali ke mal',
            ordersn_empty: 'Pesanan SN wajib diisi',
            order_search_error: 'Kesalahan yang tidak terduga',
            goodsName:'Nama Produk'
        },

        //fail page
        fail: {
            payment_fail: 'Pembayaran gagal',
            back_home: 'Kembali ke Rumah'
        }
    },
    CountryGroup: {
        title: "Negara/wilayah",
        placeholder: "Cari negara atau wilayah",
        clear: "Jernih",
        history: "Riwayat Pencarian"
    },
    PromotionCode: {
        verification: {
            title: "Kode Voucher",
            minititle: "Kode Voucher",
            input: "Silakan masukkan kode isi ulang",
            explain: "Tips: Sentuh tombol pindai di kanan atas untuk memindai kode QR kartu voucher, atau masukkan kode voucher secara manual (peka huruf besar-kecil) jika tidak berhasil.",
            submit: "Kirim",
            exchange: "Menukarkan",
            cancel: "Membatalkan",
            Inquiry: "Apakah Anda yakin untuk bertukar",
            ErrorCode: "Kesalahan Kode Isi Ulang"
        },
        recharge_success: {
            package: "Kemasan",
            content: "Berhasil Ditebus",
            back: "Kembali ke Pusat Perbelanjaan",
            view_packets: "Buka Paket Saya"
        }
    },
    order: {
        state: {
            inUse: "Diaktifkan",
            isFirst: "Diprioritaskan",
            toFirst: "Tetapkan Prioritas",
            inactive: "Dinonaktifkan"
        },
        periodUnits: {
            minute: "menit",
            hour: "jam",
            day: "hari",
            month: "bulan"
        },
        useIntro: {
            tip1: "Paket data unlimited mempunyai prioritas lebih tinggi dibandingkan paket data volume;",
            tip2: "Prioritas penggunaan akan didasarkan pada tanggal pembelian untuk jenis paket yang sama, yaitu paket dengan tanggal pembelian paling awal akan digunakan terlebih dahulu, sedangkan prioritas paket satu wilayah lebih tinggi daripada paket regional;",
            tip3: "Anda juga dapat secara manual mengatur prioritas penggunaan paket dengan tipe yang sama."
        },
        myFlow: "Data saya",
        remainingFlow: "Datanya tersisa",
        remainingTime: "Berlaku di kiri",
        remainingHighFlow: "Data berkecepatan tinggi tersisa",
        validPeriod: "Keabsahan",
        noneFlow: "Tidak ada paket data",
        noneFlowTip: "Silakan beli paket data dan nikmati jaringan berkualitas tinggi",
        buyPackFlow: "Beli paket",
        checkInvalidFlow: "Periksa paket data yang sudah habis masa berlakunya",
        orderList:  {
            "title": "pesanan saya",
            "amount_paid": "Total",
            "device": "Perangkat milik",
            "order_details": "Detail pesanan",
            "total_amont": "Subtotal",
            "orderSN": "Nomor pesanan.",
            "createTime": "Waktu penciptaan",
            "cancelTime": "Waktu tertutup",
            "payTime": "Waktu pemesanan",
            "unsubTime": "Waktu dibatalkan",
            "payMethod": "Metode pembayaran",
            "thirdSN": "Nomor transaksi.",
            "delete": "Menghapus",
            "cancel": "Batalkan Pesanan",
            "unsub": "Pengembalian dana",
            "goto_cancel": "Apakah Anda ingin membatalkan pesanan?",
            "goto_unsubscribe": "Apakah Anda ingin berhenti berlangganan pesanan?",
            "delete_Tips": "Pesanan tidak dapat dilanjutkan setelah dihapus, oleh karena itu masalah layanan purna jual Anda tidak dapat ditangani.Apakah Anda yakin akan menghapusnya?",
            "status_success": "Selesai",
            "status_pending": "Tidak dibayar",
            "status_cancel": "Tertutup",
            "status_unsub": "Dibatalkan",
            "payMethod_stripe": "Kartu Kredit"
          },
    },
    registerlogin: { 
        create_account_tip:"Buat akun, mulailah pengalaman eksklusif",
        select_country_tip:"Perangkat menggunakan negara/wilayah",
        email_name: "Surat",
        phone_name: "Telepon",
        email_address: "Alamat email",
        password: "kata sandi",
        country: "negara",
        select_country: "Pilih suatu negara",
        cancel: "Membatalkan",
        confirm: "Tentu",
        please_enter: "Harap masukkan 6-20 karakter (kombinasi huruf, angka atau simbol)",
        select_country_tips: "Pilihan negara adalah untuk melihat paket lokal. Itu tidak dapat diubah setelah pendaftaran. Mohon konfirmasi!",
        global_roaming: "Kode domain internasional",
        phone_number: "nomor telepon",
        agree: "setuju",
        user_agreement: "Perjanjian Pengguna",
        and: "Dan",
        privacy_policy: "Kebijakan Privasi",
        register_login: "Daftar atau Masuk",
        login_error: "Jumlah login terlalu sering, silakan coba lagi nanti!",
        register_error: "Jumlah pendaftaran terlalu sering, silakan coba lagi nanti!",
        forgot_pwd: "Lupakan kata sandinya",
        app_tips: "Masuk ke aplikasi dengan akun ini setelah mengunduhnya untuk mengakses lebih banyak fitur.",
        download_app: "Pergi untuk mengunduh aplikasi",
        rememberPwd: "Ingat kata sandi",
        third_login: "Lanjutkan dengan",
        agreement_tips: "Silakan centang kotak Perjanjian Pengguna dan Kebijakan Privasi",
        selectCountry_tips: "Mohon dicatat bahwa negara yang terdaftar akan secara langsung mempengaruhi metode pembayaran dan mata uang berikut, silakan pilih sesuai kebutuhan Anda.",
        login_error_cancel: "Pengguna membatalkan login",
        login_error_auth: "Izinkan pop-up dari pengaturan browser",
        device_tips: "Perangkat menunggu aktivasi. Kami proses dalam 24 jam."
      },
      forgotPwd: {
        forgot_pwd: "Lupakan kata sandinya",
        email_address: "Alamat email",
        next: "Berikutnya",
        email_has_been_sent: "Kami telah mengirim email ke %@email. Silakan klik tautan dan ikuti langkah-langkah untuk mengambil kata sandi Anda.",
        have_retrieved_it: "Saya telah menemukannya",
        unable_to_receive_email: "Tidak dapat menerima email? Silakan periksa apakah ada email dari %@email di bawah spam Anda dan direktori surat yang dihapus",
        or: "atau",
        resend: "Ulang",
        global_roaming: "Kode domain internasional",
        phone_number: "nomor telepon",
        verification_code_has_been_sent: "Kami telah mengirim kode verifikasi ke:",
        verification_code: "Kode verifikasi",
        no_verification_code_received: "Tidak menerima kode verifikasi?",
        please_enter: "Harap masukkan 6-20 karakter (kombinasi huruf, angka atau simbol)",
        reset_password: "Setel ulang kata sandi",
        reset_successful: "Reset berhasil"
      },
      coupons: {
        coupons_name: "Kupon",
        no_coupons: "Belum ada kupon",
        no_data: "Belum ada data",
        applicable_to_the_following: "Kupon cocok untuk paket data berikut"
      },
      digital: {
        title: "Perangkat SN",
        purchased: "Pembelian saya",
        viewAll: "Lagi",
        skinStore: "Toko produk",
        completed: "Dibeli",
        goBuy: "Membeli",
        order: {
            title: "Pesanan yang dibeli"
        },
        detail: {
            describe: "Keterangan"
        }
    },
    viewPL: {
        other: 'lainnya'
      },
    invalidFlow: {
        stateName: "Status",
        state: {
            NOT_ACTIVATED: "Dinonaktifkan",
            IN_USING: "Tersedia",
            USE_END: "Lelah",
            EXPIRE: "Kedaluwarsa",
            TRANSFER: "Transfer",
            UNSUBSCRIBE: "Membatalkan",
            VALID: "Sah",
            INVALID: "Tidak sah",
            EXCHANGE_POINTS: "Tukarkan Poin"
        },
        noneFlow: "Tidak ada paket data yang kadaluwarsa",
        pageName: "Paket data habis masa berlakunya"
    },
    flowDetail: {
        title: "Detail data",
        flow: "Data",
        validTime: "Detail data",
        invalidTime: "Berlaku sampai",
        coverage: "Cakupan",
        useIntro: "syarat dan Ketentuan",
        purchaseTime: "Dibeli di",
        subtotal: "Subtotal",
        status: "Status",
        cancel: "Membatalkan",
        buyAgain: "Beli lagi",
        validity: "Keabsahan",
        tip: "Melihat",
        cancelTip: "Apakah Anda yakin ingin mengembalikan dana paket ini?",
        dataLeft: "Datanya tersisa"
    },
    netError: {
        try_again: "Coba lagi",
        net_error: "Tidak ada jaringan",
        try_again_desc: "Silakan periksa pengaturan jaringan dan coba lagi"
    },
    loadFail: {
        try_again: "Coba lagi",
        load_fail: "Gagal memuat",
        load_fail_desc: "Pemuatan data gagal, silakan coba lagi",
        IMEI_Not_Exist: "IMEI Tidak Ada, Silakan coba masuk dari pintu masuk sebelah kanan",
        Project_Not_Exist: "Terjadi kesalahan. Silakan hubungi layanan pelanggan.(01)",
        commonError: "Terjadi kesalahan. Silakan hubungi layanan pelanggan."
    },
    settlement_Easy_and_convenient: "Mudah dan nyaman",
    settlement_Great_deal: "Banyak sekali",
    settlement_Safe_and_secure: "Aman dan aman",
    settlement_Autopay_service_regulation: "Peraturan Layanan Autopay",
    settlement_Read: "Membaca",
    settlement_No_coupon: "Tidak ada kupon yang tersedia",
    settlement_Subtotal: "Subtotal",
    settlement_Coupon: "Kupon",
    settlement_TOTAL: "Total",
    settlement_promotion_tip: "Penawaran promosi tidak dapat digunakan bersama dengan kupon apa pun",
    settlement_coupon_tip: "Kupon tidak dapat digunakan bersama dengan penawaran promosi lainnya",
    member_myFlow_noList: "Tidak ada data",
    detail_se_content: "Cara yang aman, mudah dan nyaman. Anda dapat berhenti berlangganan kapan saja",
    Enter_Promo_code: "Kode promosi",
    Enter_Promo_Coupon:"Kupon",
    settlement_Not_used_coupon:"kupon tidak digunakan",
    settlement_Available_coupon:"Tersedia",
    settlement_Unavailable_coupon:"Tidak tersedia",
    please_Enter_Promo_code: "Harap masukkan kode promosi",
    please_Select_Coupon_use:　"Pilih kupon yang ingin Anda gunakan.",
    Buy_Now: "Beli sekarang",
    Dont_Use_Any: "Jangan gunakan apapun",
    settlement_confirm: "Mengonfirmasi",
    flowDetail_unsubscribe: "Berhenti berlangganan",
    flowDetail_unsubscribed: "Tidak berlangganan",
    flowDetail_isCancelPackage: "Berhenti berlangganan paket ini?",
    flowDetail_confirmAgreementUnsubscribe: "Anda tidak dapat memiliki banyak hal setelah berhenti berlangganan. Apakah Anda yakin ingin berhenti berlangganan?",
    flowDetail_cancel: "Membatalkan",
    flowDetail_cancelSuccess: "Berhenti berlangganan dengan sukses",
    packages_detail_promotion: "Promosi",
    orderTips:{
        "iDay" : "hari",
        "iDays" : "hari -hari",
        "iMonth" : "bulan",
        "iMonths" : "bulan",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol pada pembelian pertama Anda, Bayar %@money/%@periodSymbol nanti, Anda dapat berhenti berlangganan kapan saja",
        'Monthly_discount':"Simpan %@saveMoney masing -masing %@period! Anda dapat berhenti berlangganan kapan saja ",
        'Ordinary_monthly_package':"Cara yang aman, mudah dan nyaman. Anda dapat berhenti berlangganan kapan saja",
        "AlreadyPurchased":' Maaf Anda hanya dapat berlangganan satu paket data saat ini. Silakan berhenti berlangganan dari “%@” dan berlangganan nanti ke paket apa pun yang Anda inginkan setelah kedaluwarsa.',
        "Contract_recommendation_First":'<label>Dengan layanan otomatis, pada pembelian pertama Anda, bayar saja</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Anda dapat berhenti berlangganan kapan saja'
        +'<a class="btn">Berlangganan ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Dengan layanan otomatis, bayar saja</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Anda dapat berhenti berlangganan kapan saja'
        +'<a class="btn">Berlangganan ></a></p>',
        "Contract_recommendation_General":"<label>Dengan layanan otomatis</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Cara yang aman, mudah dan nyaman. Anda dapat berhenti berlangganan kapan saja'
        +'<a href="javascript:;" class="btn">Berlangganan ></a></p>',
        'BanlanceDoubleCheck':'Apakah Anda yakin ingin membayar dengan saldo?',
    },
    feedback: {
        title: "masukan",
        placeholder: "Harap masukkan negara yang ingin Anda kunjungi atau pertanyaan lain, dan kami akan memenuhi kebutuhan Anda sesegera mungkin!",
        submit: "Kirim",
        submit_success: "Berhasil dikirim",
        other_opinions: "Opini lain"
    },
    view_country_input: 'Silakan masukkan akun Anda',
    select_package: {
        title: "Pilih Data",
        allPackage: 'Semua Data',
        type: "Tipe",
        flow: "Data",
        month_package: "Paket Bulanan",
        flow_package: "Paket Data",
        time: "Durasi",
        period: "Siklus",
        auto_debit: "Info Debit Otomatis",
        auto_subscribe: "Auto-Peranjan",
        detail: "Detail Data",
        carrier: "Operator yang Didukung",
        country: "Daftar Negara Diliputi",
        notice: "Panduan Pembelian"
      }
}